// ================================================================
// PROPRIETARY & CONFIDENTIAL — Miskulin Technologies Inc.
// Copyright (c) 2026 Miskulin Technologies. All rights reserved.
// ================================================================
import { useEffect } from 'react';
import { useAuth } from './AuthContext';

export function useTierTheme() {
  const { user } = useAuth();

  useEffect(() => {
    const tier = user?.tier || 'scale';
    document.body.classList.remove('tier-free', 'tier-growth', 'tier-scale');
    document.body.classList.add(`tier-${tier}`);
    return () => {
      document.body.classList.remove('tier-free', 'tier-growth', 'tier-scale');
    };
  }, [user?.tier]);

  return user?.tier || 'scale';
}
